import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { reducer as formReducer } from 'redux-form';
import { reducer as intent } from './reducers/intent';
import { reducer as paymentMethod } from './reducers/paymentMethod';
import { reducer as paymentConsent } from './reducers/paymentConsent';
import { reducer as request } from './reducers/request';
import { reducer as theme } from './reducers/theme';
import { reducer as qrcode } from './reducers/attemptQrcode';
import { reducer as error } from './reducers/error';
import { reducer as paymentRequestApi } from './reducers/paymentRequestApi';
import { reducer as availablePaymentMethods } from './reducers/availablePaymentMethods';

export default (history: History) =>
  combineReducers({
    request,
    theme,
    intent,
    paymentConsent,
    paymentMethod,
    paymentRequestApi,
    qrcode,
    availablePaymentMethods,
    error,
    form: formReducer,
    router: connectRouter(history),
  });
